import {Props_HeroLinks} from "./HeroLinks.props";
import SnippetLink from '../Shared/Link/Link'


const HeroLinks = (props: Props_HeroLinks) => {
    return (
        <div className="covea-hero-links">
            <h2 className="covea-hero-links__heading">
                {props.heading?.content?.value}
            </h2>
            <div className="covea-hero-links__links-container">
            {props.repeatable_links?.map((link, index) => (
                <SnippetLink 
                    key={`hero-link-${index}`}
                    url={link.linkHref?.value || link.linkHref?.value}
                    linkStyles={link.linkStyle?.value}
                    openInNewTab={link.linkTarget?.value}
                >
                    {link.linkText?.value || link.linkText?.value}
                </SnippetLink>
            ))}
            </div>
        </div>
    )
}

export default HeroLinks